exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-node-profil-path-alias-js": () => import("./../../../src/pages/{nodeProfil.path__alias}.js" /* webpackChunkName: "component---src-pages-node-profil-path-alias-js" */),
  "component---src-pages-node-seite-path-alias-js": () => import("./../../../src/pages/{nodeSeite.path__alias}.js" /* webpackChunkName: "component---src-pages-node-seite-path-alias-js" */),
  "component---src-pages-using-ssr-jsx": () => import("./../../../src/pages/using-ssr.jsx" /* webpackChunkName: "component---src-pages-using-ssr-jsx" */)
}

